import { type yup } from '@framework/validation/initYup.ts';
import { type ExpressionValue } from '../../../../expressions/evaluate/ExpressionValue.ts';
import { evaluateExpression } from '../../../../expressions/evaluate/evaluateExpression.ts';
import { ExpressionType } from '../../../../expressions/IExpression.ts';
import { type IFunctionExpression } from '../../../../expressions/repository/function/IFunctionExpression.ts';
import { type IParentWidgetScope } from '../../../IWidgetType.ts';
import { type IComputedNumberWidget } from '../IComputedWidget.ts';
import { setComputeTransform } from '../setComputedTransform.ts';

export function setComputedNumberTransform(
  widget: Pick<IComputedNumberWidget, 'expression'>,
  parentScope: IParentWidgetScope,
  schema: yup.AnySchema,
  /**
   * Funzione di trasformazione del risultato dell'espressione.
   */
  transform?: (value: ExpressionValue) => any,
) {
  // Costruisco la FunctionExpression così da poter usare
  // le funzionalità di risoluzione già esistenti
  const expression: IFunctionExpression = {
    type: ExpressionType.Function,
    value: widget.expression,
  };

  return setComputeTransform(
    expression,
    parentScope,
    schema,
    (expression: IFunctionExpression, variables: Record<string, any>) => {
      // Non possiamo fare questo tipo di filtro, in quanto le espressioni
      // **matematiche** considerano i valori nulli come **0**, es. se devo
      // fare una somma e uno dei valori è null, il risultato sarà il valore
      // non nullo.
      // Attenzione: questo porta a un comportamento chiaramente errato in caso
      // di divisione per 0, ma è un problema che è risolvibile in
      // configurazione.
      // In futuro possiamo prevedere un flag per invertire "considerNullsAsZero"
      //
      // if (Object.values(variables).some(v => v === undefined)) {
      // }

      const result = evaluateExpression(expression, { variables });

      return transform ? transform(result) : result;
    },
  );
}
